import React from 'react';
import { SelectMenu } from '@scale/scaleui';
import { ChatStandardReviewLevel } from '@scale/shared/types/chat';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';
import { ReviewLevel } from '@scale/shared-types';

interface DefaultReviewLevelRoutingBuilderProps {
  name: string;
  existingValue?: ReviewLevel[];
  updateProperty: (arg: ReviewLevel[]) => void;
  required?: boolean;
  hint?: string;
}

const DefaultReviewLevelRoutingBuilder = ({
  existingValue = [],
  updateProperty,
  name,
  required,
  hint,
}: DefaultReviewLevelRoutingBuilderProps) => {
  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-neutral-700">
        {name}
        {required && <span className="text-danger-400">*</span>}
      </label>
      <div className="flex flex-row">
        <SelectMenu
          className="min-w-[135px]"
          options={ChatStandardReviewLevel.map(s => ({
            id: String(s),
            name: String(s),
          }))}
          selectedOptionId={(existingValue?.map(String) || []) as string[]}
          setSelected={values => updateProperty(values.map(v => parseInt(v)).sort((a, b) => a - b))}
          multiple
        />
        {hint && <BuilderHint name={name} hint={hint} />}
      </div>
    </div>
  );
};

export default DefaultReviewLevelRoutingBuilder;
